<template>
  <div class="side-box" :class="{ active: opened.length > 0 }">
    <span class="side-box__overlay" />
    <div
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('removeUser') >= 0,
        'last-active': opened.indexOf('removeUser') == opened.length - 1
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
              $t("zpet")
            }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="users.length > 0">
          {{ $filters.firstUpper($t("odebrat")) }}
          <span
            v-if="users.length > 1 && users.length < 5"
          >{{ users.length }} {{ $t("uzivatele1") }}</span><span
            v-else-if="users.length > 5"
          >{{ users.length }} {{ $t("uzivatelu") }}</span><span v-else>{{ $t("uzivatele1") }} {{ users[0].email }}</span>
          {{ $t("odProjektu") }}
        </h2>
      </div>
      <div v-if="projects" class="side-box__content">
        <div class="my-4">
          <FormSelectMultiple
            :items="projects"
            :label="$t('vyberteProjekt')"
            :placeholder="$t('SELECT_PROJECT_FROM_LIST')"
            :value="selectedProjects"
            class="mb-3"
            item-text="projectName"
            item-value="projectId"
            side-box
            @change="selectedProjects = $event"
          />
        </div>
      </div>
    </div>
    <save-confirmation-modal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @yes="runSave()"
      @no="closeBox('removeUser')"
      @close="toggleConfirmation"
    />

    <div v-if="errorsToTranslate.length > 0">
      <error-modal
        :opened="openedError"
        :centered="true"
        :errors="errorsToTranslate"
        @close="
          openedError = false;
          $emit('closeBox', 'removeUser');
        "
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ErrorModal from "@/components/confirmations/translatedErrors.vue";
import SaveConfirmationModal from "@/components/confirmations/save.vue";
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue";
import { useAdminStore } from "@/store/modules/admin"
export default {
  components: {
    FormSelectMultiple,
    "save-confirmation-modal": SaveConfirmationModal,
    "error-modal": ErrorModal
  },
  props: {
    users: Array,
    opened: Array
  },
  setup() {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  data() {
    return {
      projects: [],
      selectedProjects: [],
      projectsOpened: false,
      selectProjectVisible: false,
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false
    };
  },
  computed: {
    storedCustomer() {
      return this.adminStore.customer
    }
  },
  watch: {
    storedCustomer() {
      this.loadProjects();
    }
  },
  mounted() {
    if (this.storedCustomer) {
      this.loadProjects();
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box);
    },
    closeBox(box) {
      if (box === "removeUser") {
        this.$emit("closeBox", box);
      } else {
        this.errors.endpoint = "";
        this.$emit("closeBox", box);
      }
    },
    loadProjects() {
      this.projects = [];
      axios
        .get(
          process.env.VUE_APP_API +
            "/customers/" +
            this.storedCustomer.customerId +
            "/projects?limit=1000"
        )
        .then(projectResult => {
          /**
           * read user privileges and choose only projects in privileges
           */
          axios
            .get(process.env.VUE_APP_API + "/users/" + this.users[0].userId, {})
            .then(userResult => {
              console.log("projectResult");
              console.log(projectResult.data.data);
              console.log("userResult");
              console.log(userResult.data.data[0].privileges);
              projectResult.data.data.forEach(p => {
                userResult.data.data[0].privileges.forEach(r => {
                  if (
                    (r.customerId = p.customerId && r.projectId == p.projectId)
                  ) {
                    if (this.projects.indexOf(p) == -1) this.projects.push(p);
                  }
                });
              });
              //console.log(userResult.data.data[0].privileges);
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true;
    },
    addRemoveProject(project) {
      if (this.selectedProjects.indexOf(project) == -1) {
        this.selectedProjects.push(project);
      } else {
        this.selectedProjects.splice(this.selectedProjects.indexOf(project), 1);
      }
      //
    },
    runEdit() {
      this.errorsToTranslate = [];
      let promises = [];
      this.users.forEach(item => {
        this.selectedProjects.forEach(project => {
          promises.push(
            axios
              .put(
                process.env.VUE_APP_API +
                  "/users/" +
                  item.userId +
                  "/customers/" +
                  this.storedCustomer.customerId +
                  "/projects/" +
                  project.projectId +
                  "/privileges",
                {}
              )
              .then(
                /*result*/ () => {
                  //this.$emit('closeBox', 'removeUser');
                }
              )
              .catch(error => {
                this.errorsToTranslate.push(error.data);
              })
          );
        });
      });
      Promise.all(promises).then(() => {
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true;
        } else {
          this.$emit("closeBox", "removeUser");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
